import React from 'react';
import Helpers from 'utils/helpers';
import {
  isMobileOnly,
  isTablet,
  isBrowser,
  isChrome,
  isFirefox,
  isSafari,
  isOpera,
  isIE,
  isEdge,
  isChromium
} from 'react-device-detect';

export default function AppWrapper(props) {
  const getClass = () => {
    let classNames = [];
    if (isMobileOnly) {
      classNames.push('device-mobile');
    }
    if (isTablet) {
      classNames.push('device-tablet');
    }
    if (isBrowser) {
      classNames.push('device-desktop');
    }
    if (isChrome) {
      classNames.push('browser-chrome');
    }
    if (isFirefox) {
      classNames.push('browser-firefox');
    }
    if (isSafari) {
      classNames.push('browser-safari');
    }
    if (isOpera) {
      classNames.push('browser-opera');
    }
    if (isIE) {
      classNames.push('browser-ie');
    }
    if (isEdge) {
      classNames.push('browser-edge');
    }
    if (isChromium) {
      classNames.push('browser-chromium');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div id='app' className={getClass()}>
      {props.children}
    </div>
  );
}